import { Component, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'TalkMath';

  //@ViewChild('chatbox1') chatbox1: ChatboxComponent;


}
